import { render, staticRenderFns } from "./uploadComment.vue?vue&type=template&id=586a54c0"
import script from "./uploadComment.vue?vue&type=script&lang=js"
export * from "./uploadComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports